<template>
  <div class="-gradient-slider">
    <div class="-angles">
      <button
        @click="updateAngle"
        @mouseenter="angleHover = true"
        @mouseleave="angleHover = false"
        v-tooltip.extend="{
          title: curAngle.text,
          placement: 'left',
          delay: 0,
          wrapperClass: '-label -label-color-picker',
        }"
      >
        <i :class="'wticon wticon-' + curAngle.icon"></i>
      </button>
    </div>
    <div
      class="-slider"
      :style="[sliderBackground]"
      ref="slider"
      @mousedown="
        clickOnSlider($event);
        mouseDown($event);
      "
    >
      <div
        class="-handle -handle-start"
        ref="start"
        @mousedown="
          $emit('update-selected-color', start.color, 'start');
          mouseDown($event);
        "
        :class="{
          '-active': isStartActive,
        }"
        :style="{
          left: start.position - 2 + '%',
          'background-color': start.color,
        }"
      ></div>
      <div
        class="-handle -handle-end"
        ref="end"
        @mousedown="
          $emit('update-selected-color', end.color, 'end');
          mouseDown($event);
        "
        :class="{
          '-active': isEndActive,
        }"
        :style="{
          left: end.position - 2 + '%',
          'background-color': end.color,
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import sliderMixin from '../mixins/slider.vue';

export default {
  mixins: [sliderMixin],

  props: {
    angles: {
      type: Object,
      required: true,
    },

    angle: {
      type: Number,
      required: true,
    },

    start: {
      type: Object,
      required: true,
    },

    end: {
      type: Object,
      required: true,
    },

    selected: {
      type: String,
      default: 'start',
      validator(value) {
        return ['start', 'end'].includes(value);
      },
    },

    sliderBackground: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      angleHover: false,
    };
  },

  computed: {
    curAngle() {
      return _.find(this.angles, (obj) => {
        return obj.value === this.angle;
      });
    },

    isStartActive() {
      return this.selected === 'start';
    },

    isEndActive() {
      return this.selected === 'end';
    },
  },

  watch: {
    curAngle: {
      handler(newAngle) {
        if (!this.$_tooltipHandler || !this.$_updateTooltipTitle) {
          return;
        }
        // first, update element attr title
        this.$_updateTooltipTitle(newAngle.text);
        // tooltip update title commands
        this.$_tooltipHandler('fixTitle');
        this.$_tooltipHandler('setContent');
        // the updates will hide the tooltip,
        // to prevent flicker, should wait for
        // next tick to show it again
        this.$nextTick(() => {
          // if it's still hover on button, show updated tooltip
          if (this.angleHover) {
            this.$_tooltipHandler('show');
          }
        });
      },
    },
  },

  methods: {
    updateAngle() {
      const angleKeys = Object.keys(this.angles);
      const nextAngleKey = _.find(angleKeys, (key, i, array) => {
        return i !== 0 && this.angles[array[i - 1]].value === this.angle;
      });

      this.$emit(
        'update-angle',
        nextAngleKey
          ? this.angles[nextAngleKey].value
          : this.angles[angleKeys[0]].value
      );
    },

    getSliderNewPosition(e) {
      const slider = this.$refs.slider;
      const sliderRect = slider.getBoundingClientRect();
      const difference = e.clientX - sliderRect.left;
      const divider = sliderRect.width / difference;
      return _.constrain(0, Math.round(100 / divider), 100);
    },

    clickOnSlider(e) {
      const handleStart = this.$refs.start;
      const handleEnd = this.$refs.end;
      const isClickedStart = handleStart.contains(e.target);
      const isClickedEnd = handleEnd.contains(e.target);

      // clicked on slider, and not on handlers
      if (!isClickedStart && !isClickedEnd) {
        this.setNewPosition(e);
      }
    },

    setNewPosition(e) {
      const newPosition = this.getSliderNewPosition(e);
      this.$emit(
        `update-${this.isStartActive ? 'start' : 'end'}-position`,
        newPosition
      );

      const start = this.start.position;
      const end = this.end.position;

      if (start > end) {
        this.$emit('swap-colors');
      }
    },

    onMouseMove(e) {
      this.setNewPosition(e);
    },
  },
};
</script>
